(function () {
  'use strict';

  if (window.__tekneProgramTrackingV1) return;

  var root = document.querySelector('[data-program-tracking]');
  if (!root) return;
  var expectedPath = root.getAttribute('data-page-path') || '/pages/program';
  if (window.location.pathname !== expectedPath) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') return;

  window.__tekneProgramTrackingV1 = true;

  var measurementId = root.getAttribute('data-ga4-measurement-id');
  var landingVariant = root.getAttribute('data-landing-variant') || 'program_course_v1';
  var pageHandle = root.getAttribute('data-page-handle') || 'program';
  var trackingStarted = false;
  var customGtag;
  var senderReady = false;
  var senderCheckStarted = false;
  var senderGeneration = 0;
  var pendingEvents = [];

  if (!measurementId) return;

  function analyticsAllowed() {
    try {
      return !!(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function baseParams(extra) {
    var params = {
      page_path: window.location.pathname,
      page_handle: pageHandle,
      landing_variant: landingVariant
    };

    if (window.location.search.indexOf('ga4_debug=1') !== -1) params.debug_mode = true;
    if (extra) {
      Object.keys(extra).forEach(function (key) {
        params[key] = extra[key];
      });
    }
    return params;
  }

  function dispatchEvent(name, params) {
    customGtag('event', name, baseParams(Object.assign({ send_to: measurementId }, params || {})));
  }

  function sendEvent(name, params) {
    if (!customGtag || !analyticsAllowed()) return;
    if (!senderReady) {
      if (pendingEvents.length < 20) pendingEvents.push({ name: name, params: params });
      if (!senderCheckStarted) initialiseGoogleSender();
      return;
    }
    dispatchEvent(name, params);
  }

  function syncGoogleConsent() {
    if (analyticsAllowed()) {
      startTracking();
    } else {
      senderGeneration += 1;
      senderReady = false;
      senderCheckStarted = false;
      pendingEvents.length = 0;
      if (window.location.search.indexOf('ga4_debug=1') !== -1) {
        root.setAttribute('data-ga4-sender-status', 'consent-denied');
      }
    }
  }

  function initialiseGoogleSender() {
    window.dataLayer = window.dataLayer || [];
    customGtag = typeof window.gtag === 'function' ? window.gtag : function () {
      window.dataLayer.push(arguments);
    };

    if (senderReady || senderCheckStarted) return;
    senderCheckStarted = true;
    var attemptId = ++senderGeneration;

    var clientReady = false;
    var sessionReady = false;
    var checkCount = 0;
    var maxChecks = 20;
    var debugMode = window.location.search.indexOf('ga4_debug=1') !== -1;

    function markStatus(status) {
      if (debugMode) root.setAttribute('data-ga4-sender-status', status);
    }

    function completeIfReady() {
      if (attemptId !== senderGeneration || !analyticsAllowed()) return;
      if (senderReady || !clientReady || !sessionReady) return;
      senderReady = true;
      senderCheckStarted = false;
      markStatus('ready');

      var queuedEvents = pendingEvents.slice();
      pendingEvents.length = 0;
      queuedEvents.forEach(function (event) {
        if (analyticsAllowed()) dispatchEvent(event.name, event.params);
      });
    }

    function checkExistingTag() {
      if (senderReady || attemptId !== senderGeneration) return;
      if (!analyticsAllowed()) {
        senderGeneration += 1;
        senderReady = false;
        senderCheckStarted = false;
        pendingEvents.length = 0;
        markStatus('consent-denied');
        return;
      }

      checkCount += 1;
      customGtag('get', measurementId, 'client_id', function (clientId) {
        if (clientId) clientReady = true;
        completeIfReady();
      });
      customGtag('get', measurementId, 'session_id', function (sessionId) {
        if (sessionId) sessionReady = true;
        completeIfReady();
      });

      if (!senderReady && checkCount < maxChecks) {
        window.setTimeout(checkExistingTag, 500);
      } else if (!senderReady) {
        window.setTimeout(function () {
          if (senderReady || attemptId !== senderGeneration) return;
          senderCheckStarted = false;
          pendingEvents.length = 0;
          markStatus('unavailable');
        }, 500);
      }
    }

    markStatus('checking');
    checkExistingTag();
  }

  function trackHeroReady() {
    var hero = root.querySelector('.pdp-slide.is-active');
    var heading = root.querySelector('.pdp-h1, .admatch-h1');
    if (!hero || !heading) return;

    var sent = false;
    function finish(status) {
      if (sent) return;
      sent = true;

      var readyMs = Math.round(window.performance && typeof window.performance.now === 'function' ? window.performance.now() : 0);
      var responseEndMs = 0;
      try {
        if (window.performance && typeof window.performance.getEntriesByName === 'function') {
          var entries = window.performance.getEntriesByName(hero.currentSrc || hero.src);
          if (entries.length && entries[entries.length - 1].responseEnd) responseEndMs = Math.round(entries[entries.length - 1].responseEnd);
        }
      } catch (error) {}

      sendEvent('program_hero_ready', {
        hero_ready_ms: readyMs,
        resource_response_end_ms: responseEndMs,
        image_status: status
      });
    }

    function decoded(status) {
      if (typeof hero.decode === 'function') {
        hero.decode().then(function () { finish(status); }).catch(function () { finish(status + '_decode_error'); });
      } else {
        finish(status);
      }
    }

    if (hero.complete && hero.naturalWidth > 0) {
      decoded('complete');
    } else {
      hero.addEventListener('load', function () { decoded('loaded'); }, { once: true });
      hero.addEventListener('error', function () { finish('error'); }, { once: true });
    }
  }

  function trackVisibleTime() {
    var thresholds = [1000, 3000, 10000, 30000];
    var fired = {};
    var visibleMs = 0;
    var lastTick = document.visibilityState === 'visible' ? Date.now() : null;

    function emitThresholds() {
      thresholds.forEach(function (threshold) {
        if (!fired[threshold] && visibleMs >= threshold) {
          fired[threshold] = true;
          sendEvent('program_visible_' + (threshold / 1000) + 's', {
            visible_ms: Math.round(visibleMs)
          });
        }
      });
    }

    function tick() {
      var now = Date.now();
      var allowed = analyticsAllowed();
      if (!allowed) {
        lastTick = null;
        return;
      }

      if (lastTick !== null && document.visibilityState === 'visible') visibleMs += Math.max(0, now - lastTick);
      lastTick = document.visibilityState === 'visible' ? now : null;
      emitThresholds();
    }

    var timer = window.setInterval(tick, 250);
    document.addEventListener('visibilitychange', tick);
    window.addEventListener('pagehide', function () {
      tick();
      lastTick = null;
    });
    window.addEventListener('pageshow', function () {
      lastTick = document.visibilityState === 'visible' ? Date.now() : null;
    });

    return {
      getVisibleMs: function () {
        tick();
        return Math.round(visibleMs);
      },
      stop: function () {
        window.clearInterval(timer);
      }
    };
  }

  function trackFirstInteraction(visibleTimer) {
    var eventNames = ['pointerdown', 'touchstart', 'wheel', 'keydown'];
    var handled = false;

    function handle(event) {
      if (handled || !analyticsAllowed()) return;
      handled = true;
      eventNames.forEach(function (eventName) {
        document.removeEventListener(eventName, handle, true);
      });
      sendEvent('program_first_interaction', {
        interaction_type: event.type,
        visible_ms: visibleTimer.getVisibleMs()
      });
    }

    eventNames.forEach(function (eventName) {
      document.addEventListener(eventName, handle, { capture: true, passive: true });
    });
  }

  function trackCtaClicks(visibleTimer) {
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('[data-cta-location]') : null;
      if (!target || !root.contains(target)) return;

      if (target.getAttribute('aria-disabled') === 'true') return;
      // Read the current market/offer together; missing monetary data must not
      // become a made-up amount or inherit a previous offer's currency/value.
      var rawValue = root.getAttribute('data-value');
      var value = Number(rawValue);
      var currency = root.getAttribute('data-currency') || '';
      var variantId = root.getAttribute('data-variant-id') || '';
      var quantity = Number(root.getAttribute('data-quantity') || '1');
      if (root.getAttribute('data-price-available') === 'false' ||
          rawValue === null || rawValue.trim() === '' || !isFinite(value) || value <= 0 ||
          !/^[A-Z]{3}$/.test(currency) || !/^\d+$/.test(variantId) ||
          !isFinite(quantity) || quantity < 1 || Math.floor(quantity) !== quantity) return;

      sendEvent('program_cta_click', {
        cta_location: target.getAttribute('data-cta-location') || 'unknown',
        variant_id: variantId,
        value: value,
        quantity: quantity,
        currency: currency,
        visible_ms: visibleTimer.getVisibleMs()
      });
    }, true);
  }

  function startTracking() {
    if (!analyticsAllowed()) return;
    if (trackingStarted) {
      if (!senderReady && !senderCheckStarted) initialiseGoogleSender();
      return;
    }
    trackingStarted = true;

    initialiseGoogleSender();
    var visibleTimer = trackVisibleTime();
    trackHeroReady();
    trackFirstInteraction(visibleTimer);
    trackCtaClicks(visibleTimer);
  }

  document.addEventListener('visitorConsentCollected', syncGoogleConsent);
  window.addEventListener('load', syncGoogleConsent, { once: true });

  if (document.readyState === 'complete') syncGoogleConsent();
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], syncGoogleConsent);
  }
})();
